<template>
  <div id="api-calls">
    <v-card>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>API Calls For Lead: {{ leadId }}</v-toolbar-title>
          <v-spacer />

          <v-btn
            class="mr-2 mb-2"
            color="blue darken-1"
            text
            @click="$router.go(-1)"
          >
            Back to Lead Queue
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-data-table-server
          v-model:options="options"
          dense
          :headers="headers"
          :loading="loading"
          :items="items"
          :items-length="totalItems"
          class="elevation-1"
          :items-per-page-options="footerProps.itemsPerPageOptions"
          @update:options="updateTable"
        >
          <template #item.method="{ item }">
            {{ item.method.replace('App\\Services\\', '') }}
          </template>
          <template #item.endpoint="{ item }">
            <v-tooltip top>
              <template #activator="{ props }">
                <div
                  class="text-truncate"
                  style="max-width: 120px;"
                  v-bind="props"
                >
                  {{ item.endpoint }}
                </div>
              </template>
              <span>{{ item.endpoint }}</span>
            </v-tooltip>
          </template>
          <template #item.actions="{ item }">
            <v-btn
              tile
              color="primary"
              small
              text
              @click="showJsonModal('JSON Payload', item.json_payload)"
            >
              <v-icon
                dark
                left
                class="mr-1"
              >
                mdi-eye
              </v-icon>
              PAYLOAD
            </v-btn>
            <v-btn
              tile
              color="teal"
              small
              text
              @click="showJsonModal('JSON Response', item.json_response)"
            >
              <v-icon
                dark
                left
                class="mr-1"
              >
                mdi-eye
              </v-icon>
              RESPONSE
            </v-btn>
          </template>
        </v-data-table-server>
      </v-card-text>
      <JsonModal
        v-model="apiCallsJsonModal"
        :title="apiCallsJsonTitle"
        :json="apiCallsJson"
        @close-modal="closeJsonModal()"
        @click:outside="closeJsonModal()"
      />
    </v-card>
  </div>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';
import JsonModal from '@/components/JsonModal.vue';

export default {
  name: 'LeadQueueApiCallsIndex',
  components: {
    JsonModal,
  },
  mixins: [
    dataTableMixin,
  ],
  data() {
    return {
      headers: [
        { title: 'Performed Action', value: 'method' },
        { title: 'Method', value: 'http_method' },
        { title: 'Code', value: 'http_status_code' },
        { title: 'Endpoint', value: 'endpoint', width: 120 },
        { title: 'Duration', value: 'execution_time' },
        { title: 'Time', value: 'timestamp' },
        { title: 'Actions', value: 'actions', sortable: false },
      ],
      apiCallsJsonModal: false,
      apiCallsJsonTitle: '',
      apiCallsJson: {},
    };
  },
  computed: {
    leadId() {
      return this.$route.params.id;
    },
  },
  methods: {
    closeJsonModal() {
      this.apiCallsJsonModal = false;
      this.$nextTick(() => {
        this.apiCallsJson = {};
      });
    },
    showJsonModal(title, json) {
      try {
        this.apiCallsJson = JSON.parse(json);
        this.apiCallsJsonTitle = title;
        this.apiCallsJsonModal = true;
      } catch (e) {
        this.apiCallsJson = {};
      }
    },
    updateTable() {
      this.loading = true;

      return this.$axios
        .get(`api/v1/lead-queue/${this.leadId}/api-calls`, {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },
  },
};
</script>

<style></style>
